module.exports = __webpack_public_path__ + "img/surimo.d5c62d5.png";